<template>
  <el-form-item
    :label="label"
    class="customer-code"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="customerCode"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :filter-method="filter"
    >
      <!-- <el-option label="" value="" /> -->
      <el-option v-if='!required' label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      >
        <!-- <span style="float: left">{{item.label}}</span> -->
        <span style="float: left; color: #8492a6; font-size: 13px">{{item.value}}</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '顧客コード'
    },
    placeholder: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: 'customer_code'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    ownCompany: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    customerCode: {
      get () {
        return this.value
      },
      set (customerCode) {
        this.$emit('change', customerCode)
        this.options = this.optionsOriginal
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const customerCode = await this.loadCode()
    const customerCodeSet = customerCode.map(function (index, array) {
      return { value: index.customer_code, label: index.customer_name }
    })
    this.options = customerCodeSet
    this.optionsOriginal = customerCodeSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        var company = []
        if (this.ownCompany) {
          await this.$axios
            .get('/code-master', { params: { code_id: 'COMPANY_CODE' } })
            .then((res) => {
              // company = res.data.list
              if (res.data.list.length > 0) {
                var rec = {}
                this.$set(rec, 'customer_code', res.data.list[0].code_value)
                this.$set(rec, 'customer_name', res.data.list[0].code_explanation)
                company.push(rec)
              }
            })
            .catch((e) => {
              console.log(e)
            })
        }
        await this.$axios
          .get('/search-customer')
          .then((res) => {
            var connData = []
            connData = res.data.list
            if (company.length > 0) {
              connData.unshift(company[0])
            }
            // sessionStorage.setItem('customerCode', JSON.stringify(res.data.list))
            sessionStorage.setItem('customerCode', JSON.stringify(connData))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('customerCode'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-code {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
.el-select-dropdown__item span {
  padding-left: 5px;
  padding-right: 5px;
}

</style>
